// extracted by mini-css-extract-plugin
export default {"root":"CalendarDropdownContent_root__v3dg7"};